/**
 *
 */
import {gsap, Cubic} from 'gsap/all';

export default class ParallaxImg {
  /**
   * コンストラクタ
   */
  constructor(elBox, elWrap) {
    // クラス名
    this.name = 'ParallaxImg';
    this.elBox = elBox;
    this.elWrap = elWrap;
    this.rectBox = this.getRect(this.elBox);
    this.rectWrap = this.getRect(this.elWrap);
    this.preY = 0;
    this.isShow = false;

    //if ('p-topMessage__photo c-parallax' === this.elBox.getAttribute('class')) {
    //  this.isDebug = true;
    //}

    gsap.set(this.elBox,
      {opacity: 0, y: '16%'}
    );

    this.init();
  }

  init() {

  }

  getRect(el) {
    const rect = el.getBoundingClientRect();
    rect.posY = rect.top + window.pageYOffset;
    rect.posX = rect.left + window.pageXOffset;
    return rect;
  }

  /*
  getOffset(el) {
    let targetY = el.offsetTop;
    let parent = el.offsetParent;
    while (parent && parent != document.body) {
      targetY += parent.offsetTop;
      parent = parent.offsetParent;
    }
    return {top: targetY, parent: parent};
  }
  */

  resize() {
    this.rectBox = this.getRect(this.elBox);
    this.rectWrap = this.getRect(this.elWrap);
  }

  map(val, s1, e1, s2, e2) {
    return s2 + (e2 - s2) * ((val - s1) / (e1 - s1));
  }

  constrain(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  easeInOutCubic(pos) {
    if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,3);
    return 0.5 * (Math.pow((pos-2),3) + 2);
  }

  easeOutQuart(pos) {
    return -(Math.pow((pos-1), 4) -1);
  }

  easeInOutQuart(pos) {
    if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,4);
    return -0.5 * ((pos-=2)*Math.pow(pos,3) - 2);
  }

  currentScrollY() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }

  render() {
    const winH = window.innerHeight;
    const scY = this.currentScrollY();
    const s1 = this.rectBox.posY - winH;
    const e1 = this.rectBox.posY + this.rectBox.height;
    const ty = this.constrain(this.map(scY, s1, e1, 0, 1), 0, 1);
    const s2 = (this.rectWrap.height - this.rectBox.height) * -1;
    const e2 = 0;
    const y = this.map(this.easeInOutCubic(ty), 0, 1, s2, e2);

    //if (this.isDebug) {
      //console.log(this.preY, y, scY + (winH * 0.9), this.rectBox.posY);
    //}

    if (!this.isShow && scY + (winH * 0.85) > this.rectBox.posY) {
      this.isShow = true;
      gsap.to(this.elBox,
        {duration: 0.8, opacity: 1, y: '0%', ease: Cubic.easeOut}
      );
    }

    if (this.preY === y) return;

    this.preY = y;
    this.elWrap.style.transform = `translateY( ${this.preY}px )`;
  }
}
